export default __webpack_public_path__ + "static/media/linkedin_icon.e61d78e5.webp";